import React from "react";
import styled from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { SpaceType } from "@components/atoms/Spacer/types";
import { TouchableOpacity } from "react-native";
import { MenuItemProps } from "./types";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";

const MenuItem = ({
  rightIcon,
  leftIcon,
  rightIconTheme,
  leftIconTheme,
  itemLeftText,
  itemRightText,
  onPress,
  disabled,
  isSelected,
  arrLength,
  arrIndex,
  ...restProps
}: MenuItemProps) => {
  const theme = useTheme();
  const isTablet = theme.isTablet || theme.isLargeScreen;
  const typography = useTypographyStore();
  return (
    <TouchableOpacity onPress={onPress} disabled={disabled} {...restProps}>
      <Overlay
        isSelected={isSelected}
        isTablet={isTablet}
        arrLength={arrLength}
        arrIndex={arrIndex}
      >
        <LeftLabelContainer>
          <VDBIcon
            name={leftIcon}
            size={24}
            color={isSelected && isTablet ? theme["core-01"] : leftIconTheme}
            variant={IconsVariant.VDBCustom}
          />
          {!!leftIcon && <Spacer size={SpaceType.Basic} />}
          <VDBText
            type={typography["Body-R"]}
            color={isSelected && isTablet ? theme["core-01"] : theme["core-05"]}
          >
            {itemLeftText}
          </VDBText>
        </LeftLabelContainer>
        <RightLabelContainer>
          {typeof itemRightText === "string" ? (
            <VDBText
              type={typography["Body-R"]}
              color={
                isSelected && isTablet
                  ? theme["option-cont-active"]
                  : theme["core-04"]
              }
            >
              {itemRightText}
            </VDBText>
          ) : (
            itemRightText
          )}
          {!!rightIcon && <Spacer size={SpaceType.Basic} />}
          <VDBIcon
            name={rightIcon}
            size={24}
            color={isSelected && isTablet ? theme["core-01"] : rightIconTheme}
            variant={IconsVariant.VDBCustom}
          />
        </RightLabelContainer>
      </Overlay>
    </TouchableOpacity>
  );
};

const Overlay = styled.View<{
  isSelected?: boolean;
  isTablet?: boolean;
  arrLength?: number;
  arrIndex?: number;
}>`
  padding: ${SpaceType.Extra}px ${SpaceType.Double}px;
  flex-direction: row;
  justify-content: space-between;
  ${({ theme, isSelected, isTablet, arrLength, arrIndex }) => {
    if (isSelected && isTablet && arrLength !== undefined) {
      let borderRadius = "";

      if (arrLength === 1 || (arrIndex === 0 && arrIndex === arrLength - 1)) {
        borderRadius = "border-radius: 10px;";
      } else if (arrIndex === 0) {
        borderRadius =
          "border-top-left-radius: 10px; border-top-right-radius: 10px;";
      } else if (arrIndex === arrLength - 1) {
        borderRadius =
          "border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;";
      }

      return `
        background-color: ${theme["option-bg-active"]};
        ${borderRadius}
      `;
    }
    return "";
  }}
`;

const LeftLabelContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

const RightLabelContainer = styled.View`
  flex-direction: row;
  align-items: center;
`;

export default MenuItem;
